<template>
  <noda-open-banking-widget
    v-if="showed"
    ref="paymentWidget"
    id="payment-widget"
    @click="getSession"
    :class="{
      'disabled-payment': disabled,
    }"
  />
</template>

<script>
import paymentMixin from "../payment-mixin";

import "@noda-ui/open-banking/lib/index.js";
import "@noda-ui/open-banking/lib/styles/styles.css";

import uuid from "@/shared/uuid";

export default {
  name: "NodaOpenBank",
  mixins: [paymentMixin],
  data() {
    return {
      paymentInfo: {},
      $payment: null,
    };
  },
  mounted() {
    this.$payment = this.$refs["paymentWidget"];
    if (this.$payment) {
      this.$payment.initWithParams(this.paymentInfo);
    }
  },
  created() {
    const nodeENV = process.env.NODE_ENV;
    const env =
      nodeENV === "production" || nodeENV === "uat"
        ? "PRODUCTION"
        : "DEVELOPMENT";

    this.paymentInfo = {
      apiKey: process.env.VUE_APP_NODA_PAY_KEY,
      amount: this.amount / 100,
      returnUrl: `${process.env.VUE_APP_BASE_URL}/#/receipt`,
      paymentId: uuid(),
      webhookUrl: `${process.env.VUE_APP_BASE_API_URL}/api/v1/webhook-noda`,
      description: this.description,
      customerId: this.$cookie.get("userIdentifier"),
      currency: this.currency.toUpperCase(),
      env,
      mode: "modal",
      fullWidth: true,
    };
  },
  methods: {
    async getSession() {
      await this.$axios
        .post("/api/v1/tx-noda", {
          clientPaysFee: !!this.clientPaysFee,
          qrCodes: this.paymentObject,
          amount: Number((this.paymentInfo.amount * 100).toFixed(0)),
          currency: this.currency,
          payData: JSON.stringify({
            paymentId: this.paymentInfo.paymentId,
          }),
          payerEmail: this.paymentInfo.email,
        })
        .then((response) => {
          if (response?.data?.payload?.txId) {
            this.$cookie.delete("txId");
            this.$cookie.set("txId", response.data.payload.txId);
          } else {
            console.error("txId is undefined");
          }
        });
    },
  },
  watch: {
    amount(value) {
      this.paymentInfo.amount = value / 100;
      if (this.$payment) {
        this.$payment.setParams(this.paymentInfo);
      }
    },
  },
};
</script>

<style lang="scss">
[data-locator="payment-btn"],
[data-locator="payment-container"],
#payment-widget {
  width: 100%;
  height: 100%;
}

noda-button {
  min-height: 55px !important;
  margin: 12px auto 0 auto;
  width: 100%;

  button.ndb-pi-btn {
    min-height: 55px !important;
    height: 55px;
    border-radius: 0;
    border: 1px solid #2c2e2f !important;
    box-shadow: none !important;
  }
}
.ndb-pi-btn-loading {
  width: 80% !important;
  height: auto !important;
}

.ndb-pi-btn-logo {
  max-height: 40px !important;
}
</style>
